<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogMain.type == 'create'">Nueva Seccion </h3>
                <h3 v-else>Editar Seccion </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <FormSeccion :model="seccion" :on-success="saveSeccion" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FormSeccion from '@/components/forms/SeccionForm'
export default {
  data: () => ({
    seccion: {}
  }),
  components: {
    FormSeccion
  },
  methods: {
    ...mapActions(['postUrlServicesAction']),
    saveSeccion (model) {
      this.seccion = model
      this.seccion.mapa = ''
      this.getUrl('secc.add')
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postUrlServicesAction({ url: router, data: this.seccion })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA_MAIN', 'SET_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val) {
        if (val.message) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Error!',
            text: val.message
          })
          return
        }
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Exitoso!',
          text: 'Seccion agregado.!'
        })
        this.SET_DATA_MAIN(val)
        this.cancel()
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>

</style>
